import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisApi = ApiDefinition['/ai/document-analysis/{documentId}']['POST'];
type Input = ThisApi['body'] & ThisApi['params'];
type Output = ThisApi['response'];

const generateDocumentAnalysisForDocument = async ({
  documentId,
  documentRequestUserFileId,
  documentRequestUserFileDocumentId,
}: Input): Promise<Output> => {
  const response = await noodleApiClient.post(`/ai/document-analysis/${documentId}`, {
    documentRequestUserFileDocumentId,
    documentRequestUserFileId,
  });
  return response.data;
};

export default generateDocumentAnalysisForDocument;
